(ns hai.web-app.feature-flag.ui
  "The feature-flag rows on the profile page. Each flag decides whether a group
   of nav items appears — see `show-menu-item?` in [[hai.web-app.layout]] — so
   the copy talks about the menu rather than about flags."
  (:require
   [hai.admin-ui.profile.setting-row :as row]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def section-title "Control what features you want to use")

(def lead-text
  (str "Your Humble shows only what you use. Switch a feature off and it "
       "leaves your menu. Switch it on and it comes back."))

(o/defstyled flag-lead :p
  {:font-size "14px"
   :color t/--colour-dim
   :margin "0"
   :max-width "60ch"})

(o/defstyled advanced-label :h3
  {:font-size "14px" :font-weight "700"
   :color t/--text-secondary
   :margin "6px 0 0"})

;; ---------------------------------------------------------------------------
;; Panel
;; ---------------------------------------------------------------------------

(defn feature-flags-panel []
  [row/setting-list
   [flag-lead lead-text]
   [row/setting-row-view
    {:label       "Beta features"
     :description "Access early beta features and experiments"
     :checked?    @(<s :feature-flag/beta-features?)
     :on-change   #(>e [:feature-flag/toggle-beta-features])}]
   [advanced-label "Advanced"]
   [row/setting-row-view
    {:label       "Older features"
     :description "Bring back parts of Humble you used before (chats, AI sources, solutions)"
     :checked?    @(<s :auth/legacy?)
     :on-change   #(>e [:auth/toggle-legacy])}]
   (when @(<s :auth/admin?)
     [row/setting-row-view
      {:label       "Features in progress"
       :description "Things we are still building. Expect rough edges."
       :checked?    @(<s :feature-flag/developer-features?)
       :on-change   #(>e [:feature-flag/toggle-developer-features])}])])
